// extracted by mini-css-extract-plugin
export default {"ant-switch-checked":"EditableTable_ant-switch-checked__v5eAh","tableRowLight":"EditableTable_tableRowLight__27eVl","tableRowDark":"EditableTable_tableRowDark__79d0T"};